var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.wrapperClasses,style:({maxHeight: _vm.maxHeight})},[_c(_vm.tag,{tag:"component",class:_vm.tableClasses,style:(_vm.tableStyle)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }